import embed from 'embed-video';
import getYoutubeID from 'get-youtube-id';

export default () => {
  const videos = document.querySelectorAll('[data-bg-video]');

  if (videos.length) {
    videos.forEach((el) => {
      const url = el.dataset.bgVideo;

      if (url) {
        let options = {};

        if (url.indexOf('youtube') > -1) {
          options = {
            query: {
              mute: 1,
              autoplay: 1,
              autopause: 0,
              loop: 1,
              controls: 0,
              rel: 0,
              playlist: getYoutubeID(url),
            },
          };
        } else if (url.indexOf('vimeo') > -1) {
          options = {
            query: {
              autoplay: 1,
              byline: 0,
              muted: 1,
              autopause: 0,
              loop: 1,
              background: 1,
              title: 0,
              controls: 0,
            },
          };
        }

        el.innerHTML = embed(url, options);
      }
    });
  }
};
